import axios from 'axios'

var qs = require('qs');
var root=process.env.API_ROOT

//保存
export const save = (params) => {
  return axios.post(root + '/order/printlog/save', qs.stringify(params))
}
//保存
export const saomasave = (params) => {
  return axios.post(root + '/order/printlog/saomasave', qs.stringify(params))
}

//查询
export const list = (params) => {
  return axios.post(root + '/order/printlog/list', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/order/printlog.js